/**
 * The `{base}` of a `{base} {n}` name, e.g. `Audio 2` -> `Audio`, so a copy
 * renumbers from the same base rather than growing `Audio 2 1`. A name that is
 * only a number keeps its own text.
 */
export const numberedNameBase = (name: string): string => name.trim().replace(/^(.+?)\s+\d+$/, "$1");
